import React, { useState } from 'react';
import '../styles/Root.css';
import '../styles/InformationsPratiques.css';
import museeImage from '../assets/musee.jpg';
import moyensAccesImage from '../assets/transfert/O 2 131.JPG';

const InformationsPratiques = () => {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <>
      <section className="hero">
        <h1>Informations Pratiques</h1>
        <p>Toutes les informations nécessaires pour préparer votre visite au Musée des Troupes de Marine</p>
      </section>

      <main className="grid-container">
        <section className="section-intro btn-section">
          <div className="text-container">
            <h2>Bienvenue</h2>
            <p>Bienvenue au Musée des Troupes de Marine. Cette page vous fournit toutes les informations nécessaires pour préparer votre visite, y compris les horaires d'ouverture, les moyens d'accès, les services disponibles, et les règles à suivre lors de votre visite.</p>
          </div>
          <div className="btn-container">
            <a href="tel:+33494178603" className="btn-primary">Accueil : 04 94 17 86 03</a>
          </div>
        </section>

        <section className="section-horaires btn-section">
          <div className="text-container">
            <h2>Horaires d'Ouverture</h2>
            <p>Ouvert du mardi au dimanche, de 10h00 à 18h00</p>
            <p>Fermeture hebdomadaire : Lundi</p>
            <p>Fermeture annuelle : de Noël à Nouvel An</p>
          </div>
          <div className="btn-container">
            <a href="visiteguidee.html" className="btn-secondary">Réserver une visite guidée</a>
          </div>
        </section>

        <section className="section-gratuite">
          <img src={museeImage} alt="Gratuité" />
          <div className="overlay">
            <h2>Accès gratuit</h2>
            <p> Salles climatisées</p>
          </div>
        </section>

        <section className="section-plan">
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2893.9591441623437!2d6.7408344!3d43.438279!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12cea61ba4a44c5f%3A0xed0e5466be88d1eb!2s240%20Avenue%20du%20Mus%C3%A9e%20des%20Troupes%20de%20Marine%2C%2083600%20Fr%C3%A9jus!5e0!3m2!1sfr!2sfr!4v1713973920107!5m2!1sfr!2sfr" 
            width="100%" 
            height="450" 
            style={{ border: 0 }} 
            allowFullScreen="" 
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade"
            title="Adresse du Musée"
          ></iframe>
        </section>

        <section className="section-acces-image">
          <img src={moyensAccesImage} alt="Moyens d'Accès" />
        </section>

        <section className="section-acces">
          <h2>Comment Venir au Musée : </h2>
          <div className="faq-item" onClick={() => toggleFaq(0)}>
            <h3>En venant d'Aix-en Provence par l'A 8 <i className={`fas fa-chevron-down ${openFaq === 0 ? 'open' : ''}`}></i></h3>
            <div className="faq-content" style={{ display: openFaq === 0 ? 'block' : 'none' }}>
              <p><i className="fas fa-road"></i> Prendre la sortie 38 vers St Raphaël-Fréjus Centre</p>
              <p><i className="fas fa-road"></i> Continuer sur la D4 A</p>
              <p><i className="fas fa-circle"></i> Au rond point du Bonfin, prendre la 3e sortie sur D4 A, traverser l'autoroute</p>
              <p><i className="fas fa-circle"></i> Au rond-point du Capitou, prendre la 3e sortie sur Rue du Caporal El Hadj Houidef</p>
              <p><i className="fas fa-circle"></i> Au 2e rond-point, prendre la 2e sortie sur Av. du Musée des Troupes de Marine</p>
            </div>
          </div>
          <div className="faq-item" onClick={() => toggleFaq(1)}>
            <h3>En venant de Nice par l'A 8 <i className={`fas fa-chevron-down ${openFaq === 1 ? 'open' : ''}`}></i></h3>
            <div className="faq-content" style={{ display: openFaq === 1 ? 'block' : 'none' }}>
              <p><i className="fas fa-road"></i> Prendre la sortie 38 vers Saint Raphaël-Fréjus-Centre</p>
              <p><i className="fas fa-road"></i> Continuer sur Av. Jean Lachenaud</p>
              <p><i className="fas fa-circle"></i> Au rond-point, prendre la 1re sortie sur Av. Jean Lachenaud</p>
              <p><i className="fas fa-circle"></i> Au rond point du Bonfin, prendre la 1re sortie sur D4 A, traverser l'autoroute</p>
              <p><i className="fas fa-circle"></i> Au rond-point du Capitou, prendre la 3e sortie sur Rue du Caporal El Hadj Houidef</p>
              <p><i className="fas fa-circle"></i> Au 2e rond-point, prendre la 2e sortie sur Av. du Musée des Troupes de Marine</p>
            </div>
          </div>
          <div className="faq-item" onClick={() => toggleFaq(2)}>
            <h3>En venant de Puget (de l'ouest) ou en venant de Fréjus (de l'Est) par la DN 7 <i className={`fas fa-chevron-down ${openFaq === 2 ? 'open' : ''}`}></i></h3>
            <div className="faq-content" style={{ display: openFaq === 2 ? 'block' : 'none' }}>
              <p><i className="fas fa-road"></i> A carrefour DN 7 - D 4 (DECATHLON)</p>
              <p><i className="fas fa-road"></i> Prendre la direction nord sur D 4 sur 4,3 km</p>
              <p><i className="fas fa-circle"></i> Au rond-point, prendre la 2e sortie sur Rue des Combattants d'Afrique du Nord - D 4</p>
              <p><i className="fas fa-circle"></i> Au rond-point, continuer tout droit pour rester sur Rue des Combattants d'Afrique du Nord - D 4</p>
              <p><i className="fas fa-circle"></i> Au 6e rond-point, prendre la 3e sortie sur Av. du Musée des Troupes de Marine</p>
            </div>
          </div>
        </section>

        <section className="section-services">
          <h2>Services Disponibles</h2>
          <ul>
            <li>Visites guidées</li>
            <li>Audioguides français / anglais en cours de réalisation</li>
            <li>Boutique de souvenirs</li>
            <li>Distributeur de boissons</li>
            <li>Accès personnels à mobilité réduite</li>
          </ul>
        </section>

        <section className="section-regles">
          <h2>Règles :</h2>
          <p>Pour une visite agréable et sécurisée, merci de respecter les règles suivantes :</p>
          <ul>
            <li>Interdiction de fumer, de manger et de boire</li>
            <li>Animaux non autorisés (sauf chiens d'assistance)</li>
            <li>Photographies autorisées sans flash</li>
            <li>Enfants de moins de 12 ans accompagnés</li>
          </ul>
        </section>
      </main>
    </>
  );
};

export default InformationsPratiques;

